import useSWR from "swr";
import { CONSTANTS } from "@/constants";
import { Erc20__factory } from "@/contracts";
import { sharedProvider } from "@/utils/share-provider";

async function fetchWLD({ address }: { address: string }) {
  if (!address) {
    throw new Error("Invalid address");
  }

  try {
    const wld = CONSTANTS.TOKEN_ADDRESS;
    if (!wld) {
      throw new Error("Invalid address");
    }
    const provider = sharedProvider.get(CONSTANTS.RPC);

    const contract = Erc20__factory.connect(wld, provider);
    const data = await contract.balanceOf(address);

    return data;
  } catch (error: any) {
    const msg =
      error?.message ??
      error?.shortMessage ??
      error?.code ??
      "Fetch balance fail";
    throw new Error(msg);
  }
}

export function useBalanceWLD(address: string) {
  const data = useSWR({ key: "balance-wld", address: address }, fetchWLD);
  return data;
}
